/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import DashboardStats from '../model/DashboardStats';
import InlineResponse200 from '../model/InlineResponse200';

/**
* Dashboard service.
* @module api/DashboardApi
* @version v0.3
*/
export default class DashboardApi {

    /**
    * Constructs a new DashboardApi.
    * @alias module:api/DashboardApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the dashboardStatsGet operation.
     * @callback moduleapi/DashboardApi~dashboardStatsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DashboardStats{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Top-line stats for the coordinator dashboard
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#10060; &lt;s&gt;M2M&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt;
     * @param {module:api/DashboardApi~dashboardStatsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    dashboardStatsGet(callback) {

      let postBody = null;

      let pathParams = {

      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DashboardStats;

      return this.apiClient.callApi(
        '/dashboard/stats', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the dashboardSurgeriesGet operation.
     * @callback moduleapi/DashboardApi~dashboardSurgeriesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InlineResponse200>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List surgeries for the coordinator dashboard
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#10060; &lt;s&gt;M2M&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt;
     * @param {Object} opts Optional parameters
     * @param {String} opts.on Shortcut filter: yesterday | today | tomorrow | completed_30_plus
     * @param {Date} opts.from
     * @param {Date} opts.to
     * @param {Number} opts.limit
     * @param {module:api/DashboardApi~dashboardSurgeriesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    dashboardSurgeriesGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {

      };
      let queryParams = {
        'on': opts['on'],'from': opts['from'],'to': opts['to'],'limit': opts['limit']
      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [InlineResponse200];

      return this.apiClient.callApi(
        '/dashboard/surgeries', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}
